import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "load-more-comments"
}
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentItemComponent = _resolveComponent("CommentItemComponent")!
  const _component_CommentTextfieldComponent = _resolveComponent("CommentTextfieldComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["comment_container", { isRepost: _ctx.postType === 'repost' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (item) => {
        return (_openBlock(), _createBlock(_component_CommentItemComponent, {
          key: item._id,
          comment: item,
          sourceId: item._id,
          sourceType: _ctx.sourceType,
          postId: _ctx.sourceId,
          "all-comments": _ctx.comments
        }, null, 8, ["comment", "sourceId", "sourceType", "postId", "all-comments"]))
      }), 128))
    ]),
    (_ctx.hasMoreComments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "load-more-btn",
            disabled: _ctx.isLoadingMoreComments,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMoreComments && _ctx.loadMoreComments(...args)))
          }, _toDisplayString(_ctx.isLoadingMoreComments ? "Loading..." : "Load More"), 9, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.postType === 'repost')
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: ".postDetailsWrapper",
          defer: ""
        }, [
          _createVNode(_component_CommentTextfieldComponent, {
            class: _normalizeClass({ isRepost: _ctx.postType === 'repost' }),
            sourceId: _ctx.sourceId,
            sourceType: _ctx.sourceType,
            postId: _ctx.sourceId
          }, null, 8, ["class", "sourceId", "sourceType", "postId"])
        ]))
      : (_openBlock(), _createBlock(_component_CommentTextfieldComponent, {
          key: 2,
          sourceId: _ctx.sourceId,
          sourceType: _ctx.sourceType,
          postId: _ctx.sourceId
        }, null, 8, ["sourceId", "sourceType", "postId"]))
  ], 2))
}